// This is for React Router Dom v6 to Get Params and Push History

import { useParams, useNavigate } from "react-router-dom";
import React, { Component }  from 'react';

export function withParamsAndNavigate(Component:any) {
    return (props:any) => (
        <Component {...props} params={useParams()} navigate={useNavigate()} />
    );
}